import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-12">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-15">
            La evidencia no es solo anecdótica
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full mb-8" data-id="element-16"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream p-8 md:p-12 rounded-2xl border border-blush/30 shadow-lg relative text-left" data-id="element-17">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-terracotta/20 rotate-180" data-id="element-18" />

          <div className="relative z-10 space-y-6 text-lg text-brown-light leading-relaxed" data-id="element-19">
            <p data-id="element-20">
              Los estudios de{' '}
              <span className="font-bold text-brown" data-id="element-21">John Gottman</span> — el
              investigador de relaciones de pareja más citado del mundo —
              muestran que las parejas que mantienen rituales breves y
              consistentes de conexión y resolución de conflictos tienen índices
              significativamente más altos de satisfacción relacional a largo
              plazo.
            </p>
            <p data-id="element-22">
              Su trabajo sobre la transición a la paternidad, documentado en{' '}
              <span className="italic" data-id="element-23">And Baby Makes Three</span>, es la base
              científica de que pequeñas intervenciones diarias pueden
              transformar la dinámica de pareja.
            </p>
            <p data-id="element-24">
              De hecho, investigaciones sobre rutinas breves de conexión — como
              la conocida "regla de los 10 minutos" — confirman que estructuras
              cortas y repetibles pueden reducir la tensión y fortalecer el
              vínculo de forma sostenida.
            </p>
          </div>

          <div className="mt-8 pt-8 border-t border-brown/10 text-center" data-id="element-25">
            <p className="font-serif text-xl text-terracotta font-medium" data-id="element-26">
              El método Acuerdos Express aplica exactamente ese principio:{' '}
              <br data-id="element-27" />
              <span className="font-bold" data-id="element-28">
                en 10 minutos, de forma consistente, con estructura.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}